<!-- eslint-disable vue/no-template-key -->
<template>
  <div class="base_container">
    <p class="pre-title">基本信息</p>
    <div class="base_content" :class="{'morestyle':!infoMore}">
      <div v-for="field in baseInfoField" :key="field.prop" class="base_item">
        <div class="content_label">
          <span class="label">{{ field.label }}</span>
        </div>
        <slot v-if="field.slot" :name="field.slot"></slot>
        <div v-else class="content_value">
          <template v-for="(option) in field.options" >
            <el-col :key="option.value" :span="4">
              <div class="option_content">
                <img class="active_icon" :src="isActive(field.prop,option.value)?active:noactive" >
                <span :class="{'option_item':true,'active_item':isActive(field.prop,option.value)}">{{ option.label }}</span>
                <!-- <img v-if="fileList(field.prop,option.value)" class="picture_icon" :src="picture" @click="handleClick(option.imgProp)" > -->
                <el-image 
                v-if="fileList(field.prop,option.value)&&fileList(field.prop,option.value).length"
                class="picture_icon"
                :src="picture" 
                :preview-src-list="fileList(field.prop,option.value)">
              </el-image>
              </div>
            </el-col>
          </template>
        </div>
      </div>
    </div>
    <show-more :is-more="infoMore" @changeMore="changeInfoMore('infoMore')" />
  </div>
</template>

<script>
import ShowMore from './Showmore.vue';
import active from '../image/active.svg'
import noactive from '../image/noactive.svg'
import picture from '../image/picture.svg'

  export default {
    name:'BaseInfo',
    components:{
      ShowMore
    },
    props:{
      infoMore:{
        type:Boolean,
        default:false
      },
      detail:{
        type:Object,
        default:()=>{}
      },
      baseInfoField:{
        type:Array,
        default:()=>[]
      }
    },
    data(){
      return{
        noactive,
        active,
        picture,
      }
    },
    computed:{
      isActive(){
        return (prop,value)=>{
          if(prop==='authenticationPicture'){
            return this.detail[prop]?.map(item=>item.fileCode)?.includes(value)||false
          }
          return this.detail[prop]?.includes(value)||false
        }
      },
      fileList(){
        return (prop,value)=>{
          if(prop==='authenticationPicture'){
            return this.detail[prop]?.find(item=>item.fileCode===value)?.filePath||false
          }
          return false
        }
      }
    },
    methods:{
      changeInfoMore(type){
        this.$emit('changeInfoMore',type)
      },
      handleClick(url){
        console.log(url);
      }
    }
  }
</script>

<style lang="less" scoped>
.morestyle{
  height: 40px;
  overflow: hidden;
}
.base_content{
  // padding: 0 32px;
  margin-bottom: 24px;
  .base_item{
    display: flex;
    // line-height: 54px;
    padding: 16px 0 8px 0;
    border-bottom:  1px solid #E6EAF0;
    &:last-child{
      border-bottom:  none;
    }
  }
}
.base_container{
  padding: 30px 0;
  background: #fff;
  margin-bottom: 24px;
  border-radius: 6px;
}
.pre-title {
   font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #1C2026;
    font-weight: bold;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      width: 4px;
      height: 16px;
      display: block;
      background: #06b880;
      border-radius: 2px;
      margin-right: 8px;
    }
  }
  .label{
    font-weight: 400;
    font-size: 14px;
    color: #505762;
  }
  .option_item{
    font-weight: 400;
    font-size: 14px;
    color: #B0B7C2;
  }
  .active_item{
    font-weight: 400;
    font-size: 14px;
    color: #1C2026;
  }
  .option_content{
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  .active_icon{
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  .picture_icon{
    cursor: pointer;
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
  .content_label{
    flex: 1;
  }
  .content_value{
    flex: 5;
  }
</style>